var Mailer = require('./mailer')

module.exports = Backbone.Collection.extend({
	model: Mailer,

	url: function() {
		return App.apiRoot + 'mailer'
	}
})
